var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _polygon, _ellipse, _polygon2, _polygon3, _path5, _path6, _path7, _path8, _rect4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _circle2, _path26, _path27, _polyline, _rect5, _rect6, _rect7, _g, _rect8, _polygon4, _polygon5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.03 119.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2662.31,
    y1: 408.8,
    x2: 2718.13,
    y2: 453.38,
    gradientTransform: "matrix(-1.09, 0, 0, 1, 2992.98, -359.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2689.76,
    y1: 391.04,
    x2: 2689.73,
    y2: 394.78,
    gradientTransform: "matrix(-1.09, 0, 0, 1, 2983.74, -375.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2693.58,
    y1: 391.49,
    x2: 2693.79,
    y2: 394.22,
    gradientTransform: "matrix(-1.09, -0.01, -0.01, 1, 2996.71, -330.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 112.77,
    y1: 79.1,
    x2: 134.08,
    y2: 127.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1899.64,
    y1: 1125.84,
    x2: -1935.15,
    y2: 1156.08,
    gradientTransform: "translate(2349.04 88.39) rotate(30.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -339.8,
    y1: 1152.26,
    x2: -286.34,
    y2: 1102.85,
    gradientTransform: "translate(978.49 -718.82) rotate(30.5)",
    xlinkHref: "#linear-gradient-5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.57,132.4a32.46,32.46,0,0,1-14.89-6.6c-5.08-4-10.61-9.39-10.44-16.08.18-7.09,2.83-13.92,5.7-20.32,3.88-8.62,9.28-17.72,7.85-27.33-1.41-9.46.49-21.11,5.55-29.26,8-12.81,22-15.93,36-16.22,9.25-.19,18.77.35,27.2,4.17,8.86,4,15.95,11.39,25,14.83,6,2.26,12.56,2.7,18.43,5.25,7.39,3.21,13.09,9.57,16.78,16.73s5.57,15.11,7,23c2.34,13.34-3.22,30-11.23,40.93-5.34,7.26-14.28,15.67-23.47,13.91C77.26,126.49,86.25,140.75,34.57,132.4Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,41v68.73a5.64,5.64,0,0,0,5.88,5.37l31.42,0a5.66,5.66,0,0,0,5.88-5.39V41a5.63,5.63,0,0,0-5.88-5.37l-31.42,0A5.65,5.65,0,0,0,32,41Zm3,.05a3.49,3.49,0,0,1,3.62-3.33H43v.4a2.22,2.22,0,0,0,2.32,2.12l16.89,0a2.23,2.23,0,0,0,2.32-2.12v-.41h4.58A3.46,3.46,0,0,1,72.75,41v68.53a3.48,3.48,0,0,1-3.62,3.32l-30.54.05A3.47,3.47,0,0,1,35,109.62Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.49,42.45v68.73a5.64,5.64,0,0,0,5.88,5.37l31.43,0a5.67,5.67,0,0,0,5.88-5.39V42.38A5.64,5.64,0,0,0,67.8,37l-31.43.05A5.66,5.66,0,0,0,30.49,42.45Zm3,0a3.48,3.48,0,0,1,3.62-3.32h4.43v.41a2.21,2.21,0,0,0,2.32,2.11l16.89,0a2.24,2.24,0,0,0,2.32-2.13v-.4h4.58a3.47,3.47,0,0,1,3.62,3.31V111a3.48,3.48,0,0,1-3.62,3.32l-30.54,0A3.47,3.47,0,0,1,33.49,111Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.49,42.5V111a3.47,3.47,0,0,0,3.62,3.31l30.54,0A3.48,3.48,0,0,0,71.27,111V42.44a3.47,3.47,0,0,0-3.62-3.31H63.07v.4a2.24,2.24,0,0,1-2.32,2.13l-16.89,0a2.21,2.21,0,0,1-2.32-2.11v-.41H37.11A3.48,3.48,0,0,0,33.49,42.5Z",
    transform: "translate(-9.24 -16.56)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 0.21,
    stroke: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.49,42.5V111a3.47,3.47,0,0,0,3.62,3.31l30.54,0A3.48,3.48,0,0,0,71.27,111V42.44a3.47,3.47,0,0,0-3.62-3.31H63.07v.4a2.24,2.24,0,0,1-2.32,2.13l-16.89,0a2.21,2.21,0,0,1-2.32-2.11v-.41H37.11A3.48,3.48,0,0,0,33.49,42.5Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.38,
    y: 58.25,
    width: 18.1,
    height: 18.1,
    fill: "#fff",
    opacity: 0.28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.49,
    y: 43.68,
    width: 27.11,
    height: 6.62,
    fill: "#fff",
    opacity: 0.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.49,
    y: 33.9,
    width: 27.11,
    height: 6.62,
    fill: "#fff",
    opacity: 0.28
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40.77 23.64 46.57 23.63 46.57 23.16 40.77 23.17 40.77 23.64",
    fill: "url(#linear-gradient-2)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.47,
    cy: 39.89,
    rx: 0.63,
    ry: 0.58,
    transform: "translate(-9.62 -16.09) rotate(-0.56)",
    fill: "url(#linear-gradient-3)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.38 93.62 112.43 93.62 114.78 104.93 126.08 104.93 128.38 93.62",
    fill: "#3cbdea"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.38 93.62 112.43 93.62 114.78 104.93 126.08 104.93 128.38 93.62",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.45,82.79a5.57,5.57,0,0,0-.48,2.59,34.33,34.33,0,0,0,1.43,12c1.95,5.59,6.22,10,10.36,14.26-.31-.48.5-3.06.59-3.68.2-1.2.42-2.4.64-3.6a13.22,13.22,0,0,0-.66-5.7,27.37,27.37,0,0,0-6.22-11.17A25.86,25.86,0,0,0,119.45,82.79Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.45,82.79a5.57,5.57,0,0,0-.48,2.59,34.33,34.33,0,0,0,1.43,12c1.95,5.59,6.22,10,10.36,14.26-.31-.48.5-3.06.59-3.68.2-1.2.42-2.4.64-3.6a13.22,13.22,0,0,0-.66-5.7,27.37,27.37,0,0,0-6.22-11.17A25.86,25.86,0,0,0,119.45,82.79Z",
    transform: "translate(-9.24 -16.56)",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,95.85a37.15,37.15,0,0,0,2.93-9.42,12.46,12.46,0,0,0-2.24-9.36l-7.35,12a25.81,25.81,0,0,0-3.5,7.27c-1.13,4.6.23,11.57,3.39,15.17,1.68-1.53,2.38-4.95,3.25-7.06Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,95.85a37.15,37.15,0,0,0,2.93-9.42,12.46,12.46,0,0,0-2.24-9.36l-7.35,12a25.81,25.81,0,0,0-3.5,7.27c-1.13,4.6.23,11.57,3.39,15.17,1.68-1.53,2.38-4.95,3.25-7.06Z",
    transform: "translate(-9.24 -16.56)",
    fill: "url(#linear-gradient-6)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 89.73,
    width: 22.28,
    height: 5.17,
    rx: 2.59,
    fill: "#3cbdea"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.75,111.67a3.54,3.54,0,0,1,.14,1.51,2.52,2.52,0,0,1-.77,1.26,4.32,4.32,0,0,1-3,1.16.64.64,0,0,1-.41-.12.48.48,0,0,1-.15-.28,2.3,2.3,0,0,1,.39-1.65,5.12,5.12,0,0,0,.74-1.57c.2-1.07-.86-3.47,1-3.57C95.34,108.32,95.49,110.61,95.75,111.67Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.47,113.3s.43.55.22,1-2.82,3.32-5.42,2.34,2.4-2.62,2.4-2.62Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.94,111.89a.48.48,0,0,0-.53.31,1.94,1.94,0,0,1-1.53,1.1c-.74,0-1.25-.7-1.6-.6a5.57,5.57,0,0,0-1.67,2.9c.09.7,1.18.93,2.24.7a7.45,7.45,0,0,0,3.52-2.3A2.3,2.3,0,0,0,95.94,111.89Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.37,113.05a3.7,3.7,0,0,1,.43,1.59,2.65,2.65,0,0,1-.59,1.5,4.65,4.65,0,0,1-2.95,1.8.69.69,0,0,1-.47,0,.62.62,0,0,1-.21-.27,2.58,2.58,0,0,1,.11-1.85,5.43,5.43,0,0,0,.5-1.83c0-1.19-1.57-3.57.44-4C103.3,109.52,103.89,112,104.37,113.05Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.45,114.66s.57.51.43,1-2.42,4.11-5.39,3.53,2.08-3.26,2.08-3.26Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.62,113.25a.51.51,0,0,0-.51.43,2.14,2.14,0,0,1-1.45,1.46c-.79.18-1.47-.51-1.83-.34s-1.47,2.69-1.24,3.43,1.43.79,2.53.34,3.17-2.36,3.36-3.14A2.51,2.51,0,0,0,104.62,113.25Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.92,87.11c-.06.88-1.71,2.31-2.24,3-.84,1.2-1.61,2.44-2.36,3.7a14.25,14.25,0,0,0-1.53,3.2,12.37,12.37,0,0,0-.4,3c-.16,3.53.14,7.22,1.91,10.28a1.27,1.27,0,0,0,.51.54,1.32,1.32,0,0,0,.49.06H95a.46.46,0,0,0,.58-.54l0-6.79a4.3,4.3,0,0,1,.11-1.19,4,4,0,0,1,.6-1.12,23.76,23.76,0,0,1,2.1-2.59,48,48,0,0,0,4-4.33,8.55,8.55,0,0,0,1.6-4.67c0-.6.36-1-.15-1.38a3.72,3.72,0,0,0-1.16-.21C100.76,87.74,98.82,87.49,96.92,87.11Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#473f47"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.55,88.18c0,.88-1.43,2.49-1.87,3.29-.69,1.29-1.32,2.62-1.91,4a13.83,13.83,0,0,0-1.15,3.35,12.63,12.63,0,0,0-.06,3,25.65,25.65,0,0,0,.94,5.57,16.27,16.27,0,0,0,1,2.61,13.64,13.64,0,0,0,.72,1.23c.2.31.33.84.61,1.06a1.11,1.11,0,0,0,.72.17,3.24,3.24,0,0,0,1-.1c1.39-.4,1.26-1.77,1.12-2.9l-.56-4.72a4,4,0,0,1,0-1.2,3.89,3.89,0,0,1,.47-1.18,24.69,24.69,0,0,1,1.78-2.81,47.14,47.14,0,0,0,3.47-4.77,8.54,8.54,0,0,0,1-4.82c0-.61.24-1.08-.3-1.35a3.92,3.92,0,0,0-1.19-.09C106.43,88.37,104.49,88.34,102.55,88.18Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#473f47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.19,77.87c0,.78.3,1.45,1,1.68l.18,0c1.24.24,2.86-.7,4-1.52A16.07,16.07,0,0,0,98.69,77v-8.3l-6,6.17A9.72,9.72,0,0,0,92.19,77.87Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.29,78.05c0,.39-.05.78-.05,1.17,0,2.15.5,4.35-.14,6.46a2.25,2.25,0,0,0-.18,1.43,1.72,1.72,0,0,0,.9.86,17.81,17.81,0,0,0,6.2,1.65c1.6.23,3.88.7,5.36-.16a2.68,2.68,0,0,0,1.05-1.74,32.75,32.75,0,0,0,1-6.76l.06-.89c.12-2,.16-4.11.12-6.16a6.46,6.46,0,0,0-1.12-4.22,10.6,10.6,0,0,0-5.69-2.84,6.27,6.27,0,0,0-1.88-.11,8.15,8.15,0,0,0-2.53.86,4.24,4.24,0,0,0-2.25,1.8,12.65,12.65,0,0,0-1,3.4A12,12,0,0,0,97,76.13c0,.54.19,1.09.25,1.63C97.28,77.85,97.29,78,97.29,78.05Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.24,74.74a1.88,1.88,0,0,1-.92-1,10.08,10.08,0,0,1-.41-1.32,8.34,8.34,0,0,0-1.27-2.57,2.93,2.93,0,0,0-1.4-1.16,1.81,1.81,0,0,0-1.71.38c-.71.66-.55,1.56-.45,2.41.43,3.56,2.62,6.62,4.53,9.66a13.22,13.22,0,0,1,1,1.88,44.14,44.14,0,0,1,1.2,4.92c.17.56-.29,1.64-.06,2.06a.41.41,0,0,0,.25.19c.62.18,2-.39,2.53-.47.28,0,.54-.19.82-.26,1.42-.36,1.59-4.35,1.73-5.42a76.29,76.29,0,0,0,1-8.62,9.63,9.63,0,0,0-.38-3.25,3.76,3.76,0,0,0-2.13-2.36c-1.4-.51-1.92,2.5-2.09,3.31a16.46,16.46,0,0,1-.42,2.43c-.44,1.13-1.86-.29-2.35-.94s-1-1.68-1.52-2.47a10.05,10.05,0,0,0-2.71-2,1.23,1.23,0,0,0-.54-.26.83.83,0,0,0-.8.56,1.57,1.57,0,0,0-.08.31",
    transform: "translate(-9.24 -16.56)",
    fill: "#020202",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.67,65.07a1.41,1.41,0,0,0,.88.44,4.71,4.71,0,0,0,.84,0h.15a.17.17,0,0,1,.12,0s0,.08,0,.12a9.54,9.54,0,0,1,0,1.69h0c0,.1,0,.2,0,.3a.49.49,0,0,0,0,.32c.06.13.21.18.34.23a2.89,2.89,0,0,0,.77.13,3.45,3.45,0,0,0,1.55-.55,15.46,15.46,0,0,1,.15-2.88,14.92,14.92,0,0,0,.37-3.69,2.45,2.45,0,0,0-.51-1.34,2.4,2.4,0,0,0-1.83-.66,4.61,4.61,0,0,0-2.51.69c-.28.19-.31.43-.38.74-.09.49-.17,1-.22,1.47a15.79,15.79,0,0,0-.11,1.68A1.94,1.94,0,0,0,101.67,65.07Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.64,60.23a7.75,7.75,0,0,1,1.92.2,1.85,1.85,0,0,1,.91,2.27c.24.09.28-.35.47-.52s.6.06.63.36a1.76,1.76,0,0,1-.26.85,2.49,2.49,0,0,0-.11,1.68c0,.14.13.29.26.26s.23-.26.31-.36a4.24,4.24,0,0,1,.42-.43c.29-.25.61-.48.91-.73a3.49,3.49,0,0,0,1.17-2,1.61,1.61,0,0,1,.12-.48,1.27,1.27,0,0,1,.82-.53,1.49,1.49,0,0,1,.63-1.12l-.77-.07a1.3,1.3,0,0,0,.23-.62,2,2,0,0,1-1.5-.52c-.43-.34-.77-.77-1.18-1.13a4.38,4.38,0,0,0-2.83-1.1,3.75,3.75,0,0,0-2.77,1.2,2.21,2.21,0,0,0-.64,1.65C101.47,59.93,102,60.16,102.64,60.23Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#f9692d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.39,65.52h.15a.17.17,0,0,1,.12,0s0,.08,0,.12a9.54,9.54,0,0,1,0,1.69h0A2.26,2.26,0,0,0,105.3,65a9.57,9.57,0,0,1-1.9.56Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#de9f93"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.17,75.73a11.83,11.83,0,0,0,2.89,2.88,5.82,5.82,0,0,0,2.72,1,1,1,0,0,0,.38,0,1,1,0,0,0,.52-.36,3,3,0,0,0,.7-1.72,3.25,3.25,0,0,0-1.72-2.62s-4.08-1.3-4.56-1.09c-.27.12-.52.69-.7,1.19S87.17,75.73,87.17,75.73Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M90.06,78.61a5.82,5.82,0,0,0,2.72,1,1,1,0,0,0,.38,0l.18,0c1.24.24,2.86-.7,4-1.52v0l-.38-2.48a9.66,9.66,0,0,1-2.56,1.9,3.67,3.67,0,0,1-2.19.4,2.22,2.22,0,0,1-.59-.18A19.21,19.21,0,0,1,87.4,75c-.14.42-.23.78-.23.78",
    transform: "translate(-9.24 -16.56)",
    fill: "#020202",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.93,72.84l-.09-.17a4.37,4.37,0,0,0-.49-.56,5.86,5.86,0,0,0-1.13-1,12.52,12.52,0,0,0-1.5-.64.82.82,0,0,0-.59-.07.51.51,0,0,0-.27.58.85.85,0,0,0,.43.52c.11.06.25.14.24.27a.33.33,0,0,1-.07.16,1.91,1.91,0,0,0-.22.91,4.77,4.77,0,0,0,.1,1.51,2.12,2.12,0,0,0,.81,1.25A2.72,2.72,0,0,0,86,76c1.08.27,1.91,0,2.18-1.16a3.08,3.08,0,0,0-.15-1.67C88,73,88,72.94,87.93,72.84Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.1,
    cy: 36.03,
    r: 17.17,
    fill: "#3cbdea"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.12,
    cy: 18.87,
    r: 11.31,
    fill: "#3cbdea"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.88,64.26a1.06,1.06,0,0,0-1.13.82c0,.23,0,.48-.06.71-.1.49-.53.85-.74,1.31a1.53,1.53,0,0,0,.35,1.72,3,3,0,0,0,1.18.55.89.89,0,0,0,.32,0,1,1,0,0,0,.36-.15,2.67,2.67,0,0,0,.88-1.75C103.24,66.32,103.56,64.48,101.88,64.26Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M101.58,74.45a11.28,11.28,0,0,0,2,4.15,5.09,5.09,0,0,0,4,2,4.91,4.91,0,0,0,4-2.85,8.84,8.84,0,0,0,.64-5,5.13,5.13,0,0,0-.81-2.45,2.31,2.31,0,0,0-2.26-1A2.76,2.76,0,0,0,107.41,71c-.33.8-.48,1.67-.86,2.44l-1.48-3.15a6.14,6.14,0,0,0-1.25-2,2,2,0,0,0-3.34,1.06C100.33,70.9,101.16,73,101.58,74.45Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#3cbdea"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "110.3 27.66 110.3 42.65 132.96 42.65",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.48
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.44,
    y: 37.57,
    width: 3.82,
    height: 5.08,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 119.72,
    y: 32.48,
    width: 3.82,
    height: 10.17,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.45,
    y: 28.15,
    width: 3.82,
    height: 14.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G8KHDO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.93,39.48a.49.49,0,0,1,.15-.37,1.87,1.87,0,0,0,.46-.81,1,1,0,0,0-.4-1,1.89,1.89,0,0,0-.67-.32.53.53,0,0,1-.39-.58c0-.16,0-.32,0-.48a.56.56,0,0,1,.6-.51,1.73,1.73,0,0,0,.67-.16A1,1,0,0,0,95,34a4.49,4.49,0,0,0-.23-.61.56.56,0,0,1,.17-.67c.12-.09.25-.18.36-.28a.59.59,0,0,1,.74,0,1.82,1.82,0,0,0,.61.41,1,1,0,0,0,1.23-.33,2.35,2.35,0,0,0,.35-.71.53.53,0,0,1,.59-.36l.49.07a.51.51,0,0,1,.46.52,2.06,2.06,0,0,0,.24.87,1,1,0,0,0,1.06.48,2.28,2.28,0,0,0,.66-.24.55.55,0,0,1,.74.19c.09.14.21.26.31.4a.51.51,0,0,1-.06.65,2,2,0,0,0-.42.65,1,1,0,0,0,.48,1.3,3.39,3.39,0,0,0,.55.24.53.53,0,0,1,.38.53c0,.19,0,.39-.07.58a.51.51,0,0,1-.52.45,2.06,2.06,0,0,0-.82.2,1,1,0,0,0-.53,1.05,1.93,1.93,0,0,0,.23.7.53.53,0,0,1-.17.74l-.33.26a.54.54,0,0,1-.75,0,2,2,0,0,0-.68-.42,1,1,0,0,0-1.17.39,2.52,2.52,0,0,0-.33.68.52.52,0,0,1-.56.36L97.44,42a.52.52,0,0,1-.42-.48,2.25,2.25,0,0,0-.2-.84,1,1,0,0,0-1.14-.54,5.07,5.07,0,0,0-.65.24.54.54,0,0,1-.65-.12,5.19,5.19,0,0,1-.36-.46,1.57,1.57,0,0,1-.12-.3ZM98.4,35a1.75,1.75,0,0,0-1.76,1.74,1.78,1.78,0,0,0,1.7,1.75A1.75,1.75,0,1,0,98.4,35Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,34.42a1.34,1.34,0,0,1,0,.2.38.38,0,0,1-.3.36l-.36.09a.41.41,0,0,1-.48-.23,3.66,3.66,0,0,0-.26-.42.77.77,0,0,0-1.11-.12,3.08,3.08,0,0,0-.33.3.4.4,0,0,1-.51.09l-.3-.18a.41.41,0,0,1-.19-.55,2.39,2.39,0,0,0,.1-.52.75.75,0,0,0-.66-.79,5.12,5.12,0,0,0-.56,0,.39.39,0,0,1-.37-.35,1.63,1.63,0,0,0-.07-.3.41.41,0,0,1,.23-.5,2.34,2.34,0,0,0,.49-.33.72.72,0,0,0,.1-.94,2.25,2.25,0,0,0-.31-.37.43.43,0,0,1-.1-.63c.06-.08.1-.17.16-.26a.39.39,0,0,1,.51-.17,1.48,1.48,0,0,0,.66.1.68.68,0,0,0,.64-.53,2.4,2.4,0,0,0,.06-.6.44.44,0,0,1,.28-.43l.4-.1a.41.41,0,0,1,.48.25,1.43,1.43,0,0,0,.41.56.76.76,0,0,0,1-.05,2,2,0,0,0,.3-.28.42.42,0,0,1,.52-.1l.35.2a.41.41,0,0,1,.16.5,1.36,1.36,0,0,0-.11.6.74.74,0,0,0,.64.74,4.36,4.36,0,0,0,.51,0,.39.39,0,0,1,.43.34c0,.12.06.24.08.36a.37.37,0,0,1-.23.44,1.53,1.53,0,0,0-.51.36.7.7,0,0,0-.12.86,2.33,2.33,0,0,0,.37.46.4.4,0,0,1,.09.56c0,.1-.11.19-.16.28a.41.41,0,0,1-.54.19,1.19,1.19,0,0,0-.79-.06.72.72,0,0,0-.52.57,2.57,2.57,0,0,0,0,.4Zm-1.48-4.59a1.3,1.3,0,0,0-1.31,1.31,1.31,1.31,0,1,0,2.62,0A1.3,1.3,0,0,0,105.7,29.83Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fff"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.57,
    y: 50.65,
    width: 37.73,
    height: 37.73,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.37,
    y: 59.98,
    width: 26.14,
    height: 18.97,
    rx: 1.23,
    fill: "#3cbdea",
    opacity: 0.41,
    style: {
      isolation: "isolate"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.58 67.97 56.75 64.1 62.49 71.02 67.52 66.62 69.61 68.41 74.28 62.17 76.65 65.03 76.65 77.57 52.58 77.57 52.58 67.97",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.48 71.2 56.73 64.28 52.67 68.07 52.49 67.88 56.76 63.91 62.51 70.84 67.52 66.45 69.59 68.23 74.27 61.96 76.75 64.95 76.55 65.11 74.28 62.38 69.63 68.6 67.52 66.79 62.48 71.2",
    fill: "#3cbdea"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.68,
    cy: 64.94,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.61,
    cy: 68.41,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.58,
    cy: 67.97,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.52,
    cy: 66.62,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.75,
    cy: 64.1,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.49,
    cy: 71.02,
    r: 0.53,
    fill: "#3cbdea"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.33,
    cy: 62.17,
    r: 0.53,
    fill: "#3cbdea"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84,67.15a1.27,1.27,0,0,0,.33,1.15,1.18,1.18,0,0,0,.92.28,1.38,1.38,0,0,0,.86-.46.89.89,0,0,0,.49.25.42.42,0,0,0,.44-.29c0-.21-.13-.39-.2-.6s0-.33-.11-.48a1,1,0,0,0-.65-.46C85.39,66.34,84.15,66.29,84,67.15Z",
    transform: "translate(-9.24 -16.56)",
    fill: "#fdb9a9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.e026af90c17b4916095d608793187461.svg";
export { ForwardRef as ReactComponent };